module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/thumbnail/wedding.png";